<template>
  <div :class="['card', `card--${variant}`]">
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  variant?: "flat" | "bordered" | "solid" | "elevated" | "filled";
}

withDefaults(defineProps<Props>(), {
  variant: "bordered",
});
</script>

<style>
:root {
  --card-padding-top: var(--space-lg);
  --card-padding-right: var(--space-lg);
  --card-padding-bottom: var(--space-lg);
  --card-padding-left: var(--space-lg);
  --card-radius: var(--space-sm);
}
</style>

<style scoped lang="scss">
@use "../../styles/abstracts/mixins";

.card {
  @include mixins.surface;
  padding-top: var(--card-padding-top);
  padding-right: var(--card-padding-right);
  padding-bottom: var(--card-padding-bottom);
  padding-left: var(--card-padding-left);
  border-radius: var(--card-radius);
}

/* Flat - no decoration */
.card--flat {
  backdrop-filter: none;
  background-color: transparent;
}

/* Bordered */
.card--bordered {
  border: 1px solid var(--color-gray-3);
}

/* Solid - opaque background */
.card--solid {
  backdrop-filter: none;
  background-color: var(--color-surface-solid);
}

/* Elevated - with shadow */
.card--elevated {
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.08),
    0 4px 12px rgba(0, 0, 0, 0.05);
}

/* Filled - solid background */
.card--filled {
  backdrop-filter: none;
  background-color: var(--color-background);
}
</style>
